import ExaminationEventLayout from './ExaminationEventLayout';

export default ExaminationEventLayout;
